<template>
    <div>
        <!-- this modal is used for viewing and creating a conversation from the offer edit page -->
    </div>
</template>

<script>
    import {EventBus} from "../../event-bus";

    export default {
        name: 'conversation-show-from-offer-modal',
        props: {
            orderId: String,
            conversationId: String,
            redirectUrl: String,
            type: String,
        },
        data() {
            return {
                data: {}
            }
        },
        computed: {},
        watch: {},
        methods: {
            showConversation() {
                axios.get('api/get-conversation-messages/'+this.conversationId)
                    .then(response => {
                        if (response.data.status === 422) {
                            throw [true, response.data.message];
                        }

                        response.data.redirect_url = this.redirectUrl;

                        EventBus.$emit('conversationSelected', response.data);
                    })
                    .catch(e => {
                        this.$swal("Er is een fout opgetreden", e[0] === true ? e[1] : "Er is iets mis gegaan bij het ophalen van de data", "error");
                    });
            },
            createConversation() {
                this.data.redirectUrl = this.redirectUrl;
                this.data.orderId = this.orderId;
                this.data.type = this.type;

                setTimeout(() => {
                    EventBus.$emit('openNewConversationFromOfferModal', this.data);
                }, 100);
            },
        },
        mounted() {
            if (this.conversationId) {
                this.showConversation();

            } else {
                this.createConversation();
            }
        },
        created() {},
    }
</script>
